import { inject, type InjectionKey } from 'vue'
import { useI18n } from 'vue-i18n'

type MmText = { t: (key: string, values?: Record<string, unknown>) => string }
export const mmTextKey: InjectionKey<MmText> = Symbol('mm-text')

/** Specimens may supply local copy without changing the application locale. */
export function useMmText() {
  return inject(mmTextKey, undefined) || useI18n()
}
